import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueYouTubeEmbed from "vue-youtube-embed";
import VueRouter from "vue-router";
import Main from "./components/LandingPage/Main.vue";
import Emerald from "./components/Products/Emerald.vue";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import SweetAlertOptions from "./plugins/sweetAlertConfig";

Vue.use(VueSweetalert2, SweetAlertOptions);

Vue.use(VueYouTubeEmbed);
Vue.config.productionTip = false;
Vue.use(VueRouter);

const routes = [
  { path: "/", component: Main },
  { path: "/emerald", component: Emerald },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
